var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-UPS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UPS",
    clipPath: "url(#clip-UPS)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UPS-2",
    "data-name": "UPS",
    d: "M102.841,13.906C88.832,13.906,77.9,24.4,77.9,37.442V48.751h-23.3c-20.919,0-37.747,15.671-37.747,35.151V480.187c0,13.043,11.429,23.69,25.438,23.69H233.97c14.009,0,25.438-10.647,25.438-23.69V83.9c0-19.48-16.829-35.151-37.747-35.151h-23.3V37.442c0-13.045-10.937-23.536-24.946-23.536Zm227.794,0c-11.449,0-20.515,8.6-20.515,19.256V484.618c0,10.661,9.066,19.259,20.515,19.259H491.471c11.449,0,20.676-8.6,20.676-19.259V33.163c0-10.661-9.227-19.256-20.676-19.256ZM64.6,77.024H211.65c10.719,0,19.366,8.052,19.366,18.034V171.32H45.236V95.058C45.236,85.076,53.882,77.024,64.6,77.024Zm350.39,53.184L401.534,235.049l57.607-15.589L391.851,387.573,416.8,259.5l-53.666,15.589Z",
    transform: "translate(-6.844 -7.906)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUps);
export default __webpack_public_path__ + "static/media/UPS.82a297f27ffd3ba79b634880d0149174.svg";
export { ForwardRef as ReactComponent };